import axios from "axios";
const jsonConfig = require("../../Config.json");

const getTestTypes = async () => {
  try {
    const getAllResponse = await axios.get(jsonConfig.apiUrl + "TestType", {
      headers: {
        "x-functions-key": jsonConfig.key,
      },
    });

    return Promise.resolve(getAllResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default getTestTypes;
